import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { fetchData, formatDatePublic, toasterrormsg, toastsuccessmsg, BOOKABLE_CATEGORIES } from '../../../reusable'
import { KTIcon } from '../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { Tr } from '../../../_metronic/i18n/Tr'
import { Rating } from 'react-simple-star-rating'
import { Modal } from 'react-bootstrap'
import Select, { CSSObjectWithLabel } from 'react-select'
import moment from 'moment'
import Swal from 'sweetalert2'
import $ from "jquery";

const ViewRatingAndReview: FC = () => {
  let t = Tr()
   var admindata: any = sessionStorage.getItem('admin')
      admindata = JSON.parse(admindata)
  const [reviewList, setReviewList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any
  const [sortColumn, setSortColumn] = useState('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc')
  const [showInfo, setShowInfo] = useState(false) 
  const handleCloseInfo = () => {
    setShowInfo(false)
    setReviewRatingData({})
  }

  const handleShowInfo = () => setShowInfo(true)
  const [url, setUrl] = useState('')
  const [apiTerm, setApiTerm] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('1') as any
  const [reviewRatingData, setReviewRatingData] = useState<any>({})

  // Handle Report Info Modal
  const [showReportInfo, setShowReportInfo] = useState(false)

  const handleCloseReportInfo = () => {
    setShowReportInfo(false)
    setSelectedRatingId("")
    setReportData("")
    setReviewRatingData({})

  }
  const handleShowReportInfo = () => setShowReportInfo(true)
  const [selectedRatingId, setSelectedRatingId] = useState("")
  const [reportData, setReportData] = useState({}) as any

  const [categoryList] = useState(BOOKABLE_CATEGORIES) as any



  const formatDate2 = (date: any) => {
    return moment(date).format('YYYY-MM-DD')
  }

  //   rating and review list api call
  const ratingAndReviewListApiCall = async () => {
    var param: any = {
      limit: limit,
      offset: offset,
      search: apiTerm,
      categoryId: selectedCategory,
      sort: sortDirection,
      sortBy: sortColumn,
    }

    var res = await fetchData('admin/reviewCategoryWisePropertyTypeBooking ', param)

    if (res.status == '200') {
      var data = res.data
      setTotalRecords(data.totalRecords)
      setReviewList(data.data)
      setUrl(res.url)
    } else {
      toasterrormsg(res.message)
    }
  }

  const reportDetailApiCall = async (ratingId: any) => {
    const param = {
      ratingId: ratingId
    }

    var res = await fetchData('admin/viewreport', param)

    if (res.status == '200') {
      var data = res.data[0]

      if (res.data.length > 0) {
        setReportData(data)
      }
      
      return data

    } else {
      toasterrormsg(res.message)
    }
  }


  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    const escapedTerm = text.replace(/'/g, "''")
    setApiTerm(escapedTerm)
  }

  const handleSort = (column: any, sortDirection: 'asc' | 'desc') => {
    setSortColumn(column.sortField)
    setSortDirection(sortDirection)
  }
  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Property')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex align-items-center position-relative my-1 '>
          <Select
            name='selectCategory'
            id='selectCategory'
            placeholder={t('Select Category')}
            isSearchable={true}
            options={categoryList}
            value={categoryList.find((option: any) => option.value == selectedCategory) || null}
            onChange={(e: any) => {
              setSelectedCategory(e.value)
            }}
            styles={{
              option: (provided : CSSObjectWithLabel) => ({
                ...provided,
                textAlign: "left", // 👈 aligns each option
              }),
              singleValue: (provided : CSSObjectWithLabel) => ({
                ...provided,
                textAlign: "left", // 👈 aligns selected value
              }),
              placeholder: (provided : CSSObjectWithLabel) => ({
                ...provided,
                textAlign: "left", // 👈 aligns placeholder text
              }),
            }}
          />
        </div>
      </div>
    )
  }
  // Custom rating component
  const customRating = (rating: number) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '16px', fontWeight: '500', textDecorationColor: 'blue' }} className='text-primary text-decoration-underline' >{rating.toFixed(1)}</span>
        <Rating
          initialValue={rating}
          allowFraction={true}
          readonly
          size={25}
          fillColor='gold'
          emptyColor='gray'
          transition={true}
        />
      </div>
    )
  }


  const categoryRatingFields: Record<string, { key: string; label: string }[]> = {
    '1': [
      // Accommodation
      { key: 'valueForMoney', label: 'Value For Money' },
      { key: 'location', label: 'Location' },
      { key: 'staffservice', label: 'Staff Service' },
      { key: 'cleanliness', label: 'Cleanliness' },
      { key: 'facilities', label: 'Facilities' },
    ],
    '7': [
      // Car Rental
      { key: 'valueForMoney', label: 'Value For Money' },
      { key: 'vendorCommunication', label: 'Vendor Communication' },
      { key: 'accuracyOfListing', label: 'Accuracy of Listing' },
      { key: 'pickupDropoffProcess', label: 'Pick Up Drop Off Process' },
      { key: 'vehicleCondition', label: 'Vehicle Condition' },
    ],
    '5': [
      // Tour Package
      { key: 'valueForMoney', label: 'Value For Money' },
      { key: 'tourGuide', label: 'Tour Guide' },
      { key: 'itineraryAndExperience', label: 'Itinerary And Experience' },
      { key: 'transportationAndComfirt', label: 'Transportation And Comfort' },
      { key: 'punctualityAndOrganization', label: 'Punctuality And Organization' },
    ],
    '4': [
      // Space Rental
      { key: 'valueForMoney', label: 'Value For Money' },
      { key: 'location', label: 'Location' },
      { key: 'staffservice', label: 'Staff Service' },
      { key: 'cleanliness', label: 'Cleanliness' },
      { key: 'facilities', label: 'Facilities' },
    ],

    // Add more for category '5' or '4' as needed
  }

  const changeReportStatus = async (status: any, ratingId: any, currentStatus?: any) => {
    const reportDataApiCall = await reportDetailApiCall(ratingId);

    Swal.fire({
      title: 'Are you sure?',
      text: status == "3" ? t("You Want To Delete This Review") : 'You Want To Change The Report Status',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const param = {
          status: currentStatus == "1" ? 2 : status,
          ratingId: ratingId,
          categoryId: selectedCategory,
          reviewreportId: reportDataApiCall?.reviewreportId, 
          adminId:admindata.adminId
        };
        const res = await fetchData('admin/reviewreportstatuschange', param);

        if (res.status == '200') {
          ratingAndReviewListApiCall();
          setReportData("");
          setReviewRatingData({});
          toastsuccessmsg(res.message);
        } else {
          toasterrormsg(res.message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setReportData("");
        setReviewRatingData({});
      }
    });
  };

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Review Id'),
        cell: (row: any) => (
          <div className='my-3'>
            {/* <Link to={getBookingRoute()} state={{ bookingId: row.bookingId }}> */}
            <div className={`fw-bold fs-5 ${row.reviewId && row.reviewId ? "text-primary text-decoration-underline" : ""} `}>{row.reviewId && row.reviewId != '' ? "#" + row.reviewId : '-'}</div>
            {/* </Link> */}
          </div>
        ),
        sortField: 'bookingCode',
        sortable: true,
        width: '150px',
      },
      {
        name: t('Date Submitted'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created && row.created != "" ? formatDate2(row.created) : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'userName',
      },
      {
        name: t('Customer Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.userName ? row.userName : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'userName',
      },
      {
        // name: (
        //   <>
        //     {t('Accommodation/Space')}
        //     <br />
        //     {t('Tour Agency/Car SupplierName')}
        //   </>
        // ),
        name: selectedCategory == "1" ? t('Accommodation') : selectedCategory == "4" ? t('Space') : selectedCategory == "5" ? t('Tour Agency') : selectedCategory == "7" ? t('Car Supplier Name') : "",

        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.actionName ? row.actionName : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'actionName',
      },
      {

        name: selectedCategory == "1" ? t('Property Type') : selectedCategory == "4" ? t('Space Type') : selectedCategory == "5" ? t('Tour Type') : selectedCategory == "7" ? t('Car Type') : "",

        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyType ? row.propertyType : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'propertyType',
      },
      {

        name: selectedCategory == "1" ? t('Room Name') : selectedCategory == "4" ? t('Rental Space Name') : selectedCategory == "5" ? t('Tour Name') : selectedCategory == "7" ? t('Car Name') : "",

        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.actionTypeName ? row.actionTypeName : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'actionTypeName',
      },

      {
        name: t('Rating'),
        cell: (row: any) => (
          <div className='my-3'>
            <div
              className='fw-bold fs-5 cursor-pointer'
              onClick={() => {

                setReviewRatingData(row) // <-- store full row to access individual ratings
                handleShowInfo()
              }}
            >
              {row.totalRating ? <>{customRating(row.totalRating)}</> : '-'}
            </div>
          </div>
        ),
        sortable: true,
        width: '200px',

        sortField: 'totalRating',
      },
      {
        name: t('Verified Booking'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>✅</div>
          </div>
        ),
        sortable: false,
        width: '200px',
        sortField: '',
      },
      {
        name: t('Reported'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 text-center' >
              {row.isReported == "0" ? <span className='cursor-pointer' > <span className=' fw-bold '>{t('None')}</span> </span  > : <span onClick={() => {
                setSelectedRatingId(row.ratingId)
                setReviewRatingData(row)
                handleShowReportInfo()
              }} className='cursor-pointer'  > <span>🚩</span> <span className='fw-bold text-decoration-underline'> {t('View')}</span> </span>}
            </div>
          </div>
        ),
        sortable: false,
        width: '200px',
      },
      {
        name: t('Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.reportStatus == "0" || row.reportStatus == "2" ? <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Published')}</span> : row.reportStatus == "1" ? <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Hidden')}</span> : ""}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'reportStatus',
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.isReported == "1" ? (
                row.reportStatus == "0" ? (
                  <>
                    <span className='cursor-pointer' onClick={() => changeReportStatus("1", row.ratingId)}>👁️ {t("Hide")}</span>
                    {" / "}
                    <span className='cursor-pointer' onClick={() => changeReportStatus("3", row.ratingId)}>{t("Delete")} ❌</span>
                  </>
                ) : row.reportStatus == "1" ? (
                  <>
                    <span className='cursor-pointer' onClick={() => changeReportStatus("0", row.ratingId, row.reportStatus)}>☑️ {t("Publish")}</span>
                    {" / "}
                    <span className='cursor-pointer' onClick={() => changeReportStatus("3", row.ratingId)}>{t("Delete")} ❌</span>
                  </>
                ) : ""
              ) : (

                row.reportStatus == "2" ? <span className='fw-bold'>{t("Report Reviewed")}</span> :
                  <span className='fw-bold'>{t("Not Reported Yet")}</span>
              )}
            </div>
          </div>
        ),
        sortable: true,
        width: '250px',
        sortField: 'userName',
      },
    ],
    [t]
  )
  useEffect(() => {
    ratingAndReviewListApiCall()
    document.title = 'Insayr | View Review Category Wise'
  }, [limit, offset, sortColumn, sortDirection, searchTerm, selectedCategory]) // Trigger on pagination changes


  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)
    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }

  useEffect(() => {
    if (selectedRatingId) {

      reportDetailApiCall(selectedRatingId)
    }
  }, [selectedRatingId])

  return (
    <>
      <ToastContainer />

      <DataTable
        columns={column}
        data={reviewList}
        pagination
        paginationServer={true}
        onChangePage={handlePageChange}
        paginationTotalRows={totalRecords}
        paginationPerPage={limit}
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
        subHeader={true}
        subHeaderComponent={<CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />}
        onSort={handleSort}
        paginationComponentOptions={{
          rowsPerPageText: t('Rows Per Page'),
        }}
        sortServer
      />
      <Modal show={showInfo} onHide={handleCloseInfo} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          id='kt_modal_upload'
          tabIndex={-1}
          style={{ display: 'block' }}
          aria-modal='true'
          role='dialog'
        >
          <div className='modal-dialog modal-dialog-centered mw-700px'>
            <div className='modal-content'>
              <div className='form' id='kt_modal_upload_form'>
                <div className='modal-header d-flex justify-content-between border-bottom border-1 border-success'>
                  <h2 className='fw-bold'>{t('Review Details')}</h2>

                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleCloseInfo}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>

                <div className='modal-body pt-10 pb-15 px-lg-17'>
                  <div>
                    {reviewRatingData && reviewRatingData.title != '' ? (
                      <h3 className='fw-bold mb-5'>{reviewRatingData.title}</h3>
                    ) : (
                      <h3 className='fw-bold mb-5'></h3>
                    )}
                  </div>
                  {reviewRatingData && reviewRatingData.description != '' ? (
                    <div dangerouslySetInnerHTML={{ __html: reviewRatingData.description }}></div>
                  ) : (
                    <div className='text-center fw-bold fs-3'>{t('No Data Found')}</div>
                  )}

                  <div className='row mt-5'>
                    {!$.isEmptyObject(reviewRatingData) && reviewRatingData.media.length > 0 ? <h2>Review Images</h2> : ''}
                    {!$.isEmptyObject(reviewRatingData) && reviewRatingData.media
                      ? reviewRatingData.media.map((imageList: any, index: any) => (
                        <>
                          <div className='col-lg-2 col-4 d-flex flex-column mb-5' key={index}>
                            <div
                              style={{ maxWidth: 'fit-content' }}
                              className='p-2 shadow rounded-1'
                            >
                              <img
                                alt='images'
                                src={url + imageList.image}
                                width='100%'
                                className='rounded-1'
                              />
                            </div>
                          </div>
                        </>
                      ))
                      : ''}
                  </div>
                  <div className='mt-5'>
                    <h4 className='fw-bold mb-3'>Ratings:</h4>
                    <table className='table table-bordered w-100'>
                      <tbody>
                        {categoryRatingFields[selectedCategory]?.map(({ key, label }) => (
                          <tr key={key}>
                            <td className='fw-semibold'>{label}</td>
                            <td>
                              {reviewRatingData[key] ? (
                                <>
                                  {reviewRatingData[key].toFixed(1)}{' '}
                                  <Rating
                                    initialValue={reviewRatingData[key]}
                                    allowFraction
                                    readonly
                                    size={20}
                                    fillColor='gold'
                                  />
                                </>
                              ) : (
                                'N/A'
                              )}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td className='fw-bold'>TOTAL</td>
                          <td className='fw-bold'>
                            {reviewRatingData.totalRating ? (
                              <>
                                {reviewRatingData.totalRating.toFixed(1)}{' '}
                                <Rating
                                  initialValue={reviewRatingData.totalRating}
                                  allowFraction
                                  readonly
                                  size={20}
                                  fillColor='gold'
                                />
                              </>
                            ) : (
                              'N/A'
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal show={showReportInfo} onHide={handleCloseReportInfo} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          tabIndex={-1}
          style={{ display: 'block' }}
          aria-modal='true'
          role='dialog'
        >
          <div className='modal-dialog modal-dialog-centered mw-700px'>
            <div className='modal-content'>
              <div className='form'>
                <div className='modal-header d-flex justify-content-between border-bottom border-1 border-success'>
                  <h2 className='fw-bold'>
                    <i className="ki-duotone ki-flag fs-2 me-2 text-danger"></i>
                    {t('Report Information')}
                  </h2>
                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleCloseReportInfo}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                </div>

                <div className='modal-body pt-10 pb-15 px-lg-17'>

                  <div className="table-responsive">
                    <table className="table table-bordered text-white">
                      <thead>
                        <tr className='fw-bold text-uppercase'>
                          <th className='w-25'>{t('Field')}</th>
                          <th>{t('Value')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className='fw-bold'>{t('Reported By')}</td>
                          <td>
                            {/* {reviewRatingData?.vendorName} */}
                            {reviewRatingData?.actionName && (
                              <span > {reviewRatingData.actionName}</span>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td className='fw-bold'>{t('Service Type')}</td>
                          <td>
                            {(() => {
                              switch (selectedCategory) {
                                case "1": return 'Accommodation';
                                case "4": return 'Space Rental';
                                case "5": return 'Tour Agency';
                                case "7": return 'Car Supplier';
                                default: return '';
                              }
                            })()}
                          </td>
                        </tr>

                        <tr>
                          <td className='fw-bold'>{t('Date Reported')}</td>
                          <td>{reportData?.created ? formatDatePublic(reportData?.created) : ""}</td>
                        </tr>

                        <tr>
                          <td className='fw-bold'>{t('Reason Selected')}</td>
                          <td>{reportData?.en_reason}</td>
                        </tr>

                        <tr>
                          <td className='fw-bold'>{t('Vendor Comment')}</td>
                          <td>
                            {reportData?.description ? (
                              <div dangerouslySetInnerHTML={{ __html: `${reportData.description}` }} />
                            ) : (
                              <div className='text-muted'>{t('No Comment Provided')}</div>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewRatingAndReview }
